import BackToTop from './BackToTop'

export default BackToTop
// eslint-disable-next-line import/export
export * from './BackToTop'
